import { render, staticRenderFns } from "./DownloadForm.vue?vue&type=template&id=3cb798f8&scoped=true&"
import script from "./DownloadForm.vue?vue&type=script&lang=js&"
export * from "./DownloadForm.vue?vue&type=script&lang=js&"
import style0 from "./DownloadForm.vue?vue&type=style&index=0&id=3cb798f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb798f8",
  null
  
)

export default component.exports